<div class="layout-wrapper"  (click)="onLayoutClick()"
     [ngClass]="{'layout-static': app.menuMode === 'static',
                'layout-overlay': app.menuMode === 'overlay',
                'layout-slim': app.menuMode === 'slim',
                'layout-horizontal': app.menuMode === 'horizontal',
                'layout-sidebar': app.menuMode === 'sidebar',
                'layout-sidebar-static': app.menuMode === 'sidebar' && sidebarStatic,
                'layout-overlay-active': overlayMenuActive,
                'layout-mobile-active': staticMenuMobileActive,
                'layout-static-inactive': staticMenuDesktopInactive && app.menuMode === 'static',
                 'p-ripple-disabled': !app.ripple}">

    <div class="layout-main">

        <!-- <app-topbar *ngIf="isMobile() || isOverlay() || isHorizontal()"></app-topbar> -->
    <!--MENU DESABILITADO MENU MENU-->

        <!-- <app-menu *ngIf="!isMobile() && (isStatic() || isSlim() || isSidebar())"></app-menu> -->

        <app-breadcrumb></app-breadcrumb>

        <div class="layout-main-content">
            <router-outlet></router-outlet>
            <!-- <div>
                <h1 style="text-align: center;">
                    Você será redirecionado para o Portal do Aluno.
                </h1>
                <h3 style="text-align: center;">
                   Caso isto não aconteça, clique no link <a href="{{linkPortal}}" >Portal do Aluno</a>.
                </h3>
            </div>-->
        </div>

        <app-footer></app-footer>
    </div>

    <app-rightmenu></app-rightmenu>

    <app-config></app-config>

</div>
<!-- Toast: Mensagens-->
<p-toast position="top-right" [baseZIndex]="10009" closable="false">
    <ng-template let-message pTemplate="message">
      <div style="margin-left: 10px;" class="p-grid">
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-2"><i class="{{ message.icon }}" style="font-size: 2em;"></i></div>
                <div class="p-col-10"><h3>{{ message.summary }}</h3></div>
            </div>
        </div>
        <div class="p-col-12">
            <p>{{ message.detail }}</p>
        </div>
      </div>
    </ng-template>
  </p-toast>